import React from 'react';
import PrimaryButton from '@components/PrimaryButton';
import SecondaryButton from '@components/SecondaryButton';
import { CheckCircleIcon } from '@heroicons/react/20/solid';
import { useDashboardContext } from '@pages/DashboardLayout';
import basicKarte from '@assets/images/produkte/basic-karte.webp';

const StartseitenHeader = () => {
  const { user } = useDashboardContext();
  return (
    <div className="bg-white px-6 py-6 sm:py-6 lg:px-8">
      <div className="mx-auto max-w-2xl text-center">
        <h2 className="text-2xl font-bold tracking-tight text-gray-900 sm:text-3xl">
          Willkommen bei sVisit,{' '}
          <p className="inline capitalize">{user.firstName}</p>
        </h2>
        <p className="mt-2 text-lg leading-8 text-gray-600">
          Das ist dein sVisit Dashboard. Hier kannst du Einstellungen rund um
          dein Profil verwalten und deine Links und Karten verwalten.
        </p>
        <ul
          role="list"
          className="mt-8 max-w-xl space-y-8 text-gray-600 text-left"
        >
          <li className="flex gap-x-3">
            <CheckCircleIcon
              className="mt-1 h-5 w-5 flex-none text-svisit-primary-600"
              aria-hidden="true"
            />
            <span>
              <strong className="font-semibold text-gray-900">
                Links anpassen.
              </strong>{' '}
              Verwalte die Links, die auf deiner Profilseite angezeigt werden.
              Bearbeite bestehende oder füge neue hinzu.
            </span>
          </li>
          <li className="flex gap-x-3">
            <CheckCircleIcon
              className="mt-1 h-5 w-5 flex-none text-svisit-primary-600"
              aria-hidden="true"
            />
            <span>
              <strong className="font-semibold text-gray-900">
                Karten verwalten.
              </strong>{' '}
              Verwalte die physischen Karten, die mit deiner Profilseite
              verknüpft sind und bestelle neue.
            </span>
          </li>
          <li className="flex gap-x-3">
            <CheckCircleIcon
              className="mt-1 h-5 w-5 flex-none text-svisit-primary-600"
              aria-hidden="true"
            />
            <span>
              <strong className="font-semibold text-gray-900">
                Bestellungen.
              </strong>{' '}
              Erhalte eine Einsicht in deine Bestellungen.
            </span>
          </li>
        </ul>
        <figure className="mt-16">
          <img
            className="aspect-video rounded-xl bg-gray-50 object-cover"
            src={basicKarte}
            alt="sVisit Basic Karte"
          />
        </figure>
      </div>
    </div>
  );
};

export default StartseitenHeader;
